import { createCircleIcon } from '../createIcon.tsx';

export const CompassIcon = createCircleIcon('CompassIcon', <polyline points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />);
